/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */

import React, { useState } from 'react';
import { DropdownItem, DropdownMenu, DropdownToggle, Dropdown } from 'reactstrap';
import { SurveyActionData } from '../../../model/surveyData';
import { useAppSelector } from '../../../reducers';
import { getCurrentUser } from '../../../selectors/user';
import { SurveyPermissions } from '../../../services/permissions/SurveyPermissions';
import { UtrvPermissions } from '../../../services/permissions/UtrvPermissions';
import { Column, Divider } from '../../tracking-list';
import CompositeValueHistory from '../../value-history/CompositeValueHistory';
import { ColumnCommonProps } from '../survey-question-list';
import { QUESTION } from '../../../constants/terminology';

interface ColumnOptionsMenuProps extends ColumnCommonProps{
  survey?: Pick<SurveyActionData, '_id' | 'initiativeId' | 'stakeholders'>;
}

export const ColumnOptionsMenu = (props: ColumnOptionsMenuProps) => {
  const { question, handleGoToQuestion, survey } = props;

  const [showProvenanceModal, setShowProvenanceModal] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  const currentUser = useAppSelector(getCurrentUser);

  if (!question.utrv || !currentUser) {
    return null;
  }

  const utrv = question.utrv;

  const canContribute = UtrvPermissions.canContribute(utrv, survey, currentUser);
  const canVerify = UtrvPermissions.canVerify(utrv, survey, currentUser);
  const canManage = survey && SurveyPermissions.canManage(survey, currentUser);
  const isStakeholder = canManage || canContribute || canVerify;

  return (
    <>
      <Divider />
      <Column className='py-1 question-list__options-menu'>
        <Dropdown isOpen={isOpen} toggle={() => setIsOpen(!isOpen)} >
          <DropdownToggle outline color='transparent' className='px-2'>
            <i className='fas fa-bars' />
          </DropdownToggle>
          {isOpen ? <DropdownMenu>
            <DropdownItem onClick={handleGoToQuestion}>
              <i className='fa fa-fw fa-eye mr-2' />View {QUESTION.CAPITALIZED_SINGULAR}
            </DropdownItem>
            <DropdownItem disabled={!isStakeholder} onClick={() => setShowProvenanceModal(true)}>
              <i className='fa fa-fw fa-clipboard mr-2' />View Provenance
            </DropdownItem>
          </DropdownMenu> : null
          }
        </Dropdown>
      </Column>
      {showProvenanceModal ? <CompositeValueHistory
        isOpen={true}
        toggle={() => setShowProvenanceModal(false)}
        ids={[utrv._id]} /> : null}
    </>
  );
}
